import React from "react";
import Navbar from "../components/Navbar";
import ContactUs from "../components/ContactUs";
import Aside from "../components/Aside";
import Footer from "../components/Footer";

const ContactPage = () => {
  return (
    <>
      <Navbar />
      <ContactUs />
      <Aside />
      <Footer />
    </>
  );
};

export default ContactPage;
